export const formatCurrency = (amount: number | string, currency = 'NGN', lng = 'en-NG') => {
  amount = +amount;

  return new Intl.NumberFormat(lng, {
    style: 'currency',
    currency: currency
  }).format(+amount);
};
